'use client'

import Script from 'next/script'

export const TallyForm = () => {
  return (
    <>
      {/* Tally Form Embed */}
      <iframe
        data-tally-src="https://tally.so/embed/mK7GgV?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
        loading="lazy"
        width="100%"
        // height="1962"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
        title="【大野編集中】eカタログ資料DL"
      />

      {/* Tally Widget Script */}
      <Script src="https://tally.so/widgets/embed.js" strategy="lazyOnload" />
    </>
  )
}
